/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SurveyJobSearchField {
    JOB_CODE = 'job_code',
    JOB_TITLE = 'job_title',
    JOB_DESCRIPTION = 'job_description',
}
